import email from './email';
import phone from './phone';
import required from './required';

export default {
  email,
  phone,
  required,
};
